define([
	"dojo/_base/declare",
	"csi/page",
	"csi/table/New"
], function(declare, page, New) {

	return declare(New, {

		/**
		 * Disallow Save & New in this case
		 */
		_canRepeat: function() {
			return false;
		},

		/**
		 * Refresh root view after creating new batch
		 */
		postProcessSuccess: function() {
			const parentNode = this.getParent();
			if (parentNode && parentNode.Batches.length === 1) {
				page.refreshRootView();
			}
			this.inherited(arguments);
		}
	});
});